'use client'

export async function getDeviceCapabilities(): Promise<Record<string, string | number | boolean | null>> {
  const capabilities: Record<string, string | number | boolean | null> = {}

  try {
    // CPU cores
    if (navigator.hardwareConcurrency) {
      capabilities['dvc-cpu-cores'] = navigator.hardwareConcurrency
    }

    // Device memory (in GB)
    if ('deviceMemory' in navigator) {
      capabilities['dvc-device-memory'] = (navigator as any).deviceMemory
    }

    // Touch points
    if ('maxTouchPoints' in navigator) {
      capabilities['dvc-max-touch-points'] = navigator.maxTouchPoints
    }
  } catch (e) {
    // Navigator not available
  }

  // Battery level (if available)
  try {
    if ('getBattery' in navigator) {
      try {
        const battery = await (navigator as any).getBattery()
        capabilities['dvc-battery-level'] = Math.round(battery.level * 100)
      } catch (e) {
        // Battery API not available
      }
    }
  } catch (e) {
    // Navigator not available
  }

  return capabilities
}
